function autoResizeTextarea(element) {
  console.log(element.scrollHeight)
  element.style.height = element.scrollHeight + 'px'
}

const textarea = document.getElementById('textarea')
if (textarea) textarea.addEventListener('input', () => autoResizeTextarea(textarea))

const $tabList = document.querySelector('.tab-cases__list')
if ($tabList?.classList.contains('_fixed')) {
  const height = $tabList.offsetHeight
  $tabList.parentElement.style.setProperty('--tab-list-height', `${height / 16}rem`)
}
